// alterado - revisado

import React from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem4sm6xs12,
} from '../../../business-components/Grid/Grid'

import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoFinanciamentoList from '../../../business-rules/List/tipoFinanciamentoList'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoFinanciamento,
    rowPertentePageFinanciamento,
    setPageInclusaoFinanciamento,
} from './DespesasCompFinanciamento'

import {
    incrementaContFinanciamento,
    processaRegistrosDefaultIniciaisFinanciamento,
    calculaTotaisFinanciamento,
} from './DespesasServiceFinanciamento'

import DespesasFormFinanciamentoItem from './DespesasFormFinanciamentoItem'



const DespesasFormFinanciamento = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, linhaTipoLicenca }) => {

    let tipoFinanciamentoSelecionado = ''

    calculaTotaisFinanciamento(values)
    
    useSingleton(async () => {

        values.pageFinanciamento = obtemPage(values.pageFinanciamentoList, Number.parseInt(values.familiarFinanciamento))
    })

    salvaPage(values.pageFinanciamento, values.pageFinanciamentoList, Number.parseInt(values.familiarFinanciamento))
    
    let indAux = 0

    values.financiamentoPagination =
        values.financiamento
            ?
                values.financiamento.filter(item => item.familiar === Number.parseInt(values.familiarFinanciamento))
            :
                []

                

    return (
        <>
            <PanelRadioGroup
                name="familiarFinanciamento"
                value={Number.parseInt(values.familiarFinanciamento) || ''}
                onChange={(e) => {
                    values.pageFinanciamento = obtemPage(values.pageFinanciamentoList, Number.parseInt(e.target.value))
                    handleChange(e)
                }}
                list={values.totalFinanciamento}
                onBlur={
                    processaRegistrosDefaultIniciaisFinanciamento(values,
                        Number.parseInt(values.familiarFinanciamento))
                }
                helpText={HELPTEXT.financiamentoPanelRadioGroup}
            />
               
            <FieldArray name="financiamento">
                {(arrayHelpers) => (
                    <DivForm>
                        <GridContainer>
                            {values.financiamento?.map((item, ind) => {

                                tipoFinanciamentoSelecionado = pesquisaList(tipoFinanciamentoList, 
                                    item.tipoFinanciamento)

                                return item.familiar === Number.parseInt(values.familiarFinanciamento) &&
                                rowPertentePageFinanciamento(values, indAux++) ? (
                                    <GridItem4sm6xs12
                                        key={ind}
                                    >
                                        <DespesasFormFinanciamentoItem
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            handleChange={handleChange}
                                            handleSubmit={handleSubmit}
                                            setFieldValue={setFieldValue}
                                            arrayHelpers={arrayHelpers}
                                            linhaTipoLicenca={linhaTipoLicenca}
                                            tipoFinanciamentoSelecionado={tipoFinanciamentoSelecionado}
                                            item={item}
                                            ind={ind}
                                            simplificado={false}
                                        />
                                    </GridItem4sm6xs12>
                                )
                                :
                                (
                                   ''
                                )
                            })}
                        </GridContainer>

                        <TablePaginationPadraoFinanciamento
                            values={values}
                            setFieldValue={setFieldValue}
                        />

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirFinanciamento} 
                            disabled={familiaresList(values).length === 0 || !values.familiarFinanciamento ? true : false}
                            onClick={() =>
                                {
                                    incrementaContFinanciamento(values)
                                    arrayHelpers.push({
                                        id: values.contFinanciamento,
                                        familiar: Number.parseInt(values.familiarFinanciamento)
                                    })
                                    setPageInclusaoFinanciamento(values, setFieldValue)
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </>
    )
}

export default DespesasFormFinanciamento